import { getPalletLabel } from '.';

export const displayPalletsAmountAsMultipleOfTheMinimum = (
   amount: number,
   logisticMinimum: number,
) => `${amount / logisticMinimum} x ${logisticMinimum} ${getPalletLabel(logisticMinimum)}`;
